import React, { useContext, useEffect } from 'react';
import useFilters from '@hooks/useFilters';
import AppContext from '@context';
import { StatusFilterType } from '@context/reducers/filters/filters.type';
import { FiltersDataInterface, FiltersPropsInterface } from './FiltersType';
import FiltersDesktop from './Desktop';
import FiltersMobile from './Mobile';

function Filters({ isMobile = false }: FiltersPropsInterface) {
  const {
    state: {
      filters: { status: filtersStatusState },
    },
    dispatch,
  } = useContext(AppContext);
  const { addListener } = useFilters();

  const filtersData: FiltersDataInterface[] = [
    {
      label: 'Em andamento',
      slugs: ['in_progress'],
    },
    {
      label: 'Rota pendente',
      slugs: ['pending_route'],
    },
    {
      label: 'Concluídas',
      slugs: ['done_by_trucker', 'done'],
    },
    {
      label: 'Não reconhecida',
      slugs: ['unrecognized_by_trucker', 'unrecognized_by_company'],
    },
    {
      label: 'Canceladas',
      slugs: ['canceled_by_trucker', 'canceled_by_company'],
    },
  ];

  function handleToggleFilters(filtersSelected: StatusFilterType[]) {
    if (!filtersStatusState.length) {
      dispatch({
        type: 'filters_status_update',
        payload: { status: [...filtersSelected] },
      });
      return;
    }

    const hasSelectedFilter = filtersSelected.some((filterItem) =>
      filtersStatusState.includes(filterItem as StatusFilterType),
    );

    if (hasSelectedFilter) {
      dispatch({
        type: 'filters_status_update',
        payload: {
          status: filtersStatusState.filter(
            (filterItem) => !filtersSelected.includes(filterItem),
          ),
        },
      });
      return;
    }

    dispatch({
      type: 'filters_status_update',
      payload: {
        status: [...filtersStatusState, ...filtersSelected],
      },
    });
  }

  useEffect(() => {
    addListener();
  }, []);

  if (isMobile) {
    return (
      <FiltersMobile
        data={filtersData}
        handleToggleFilters={(filtersSelected) =>
          handleToggleFilters(filtersSelected)
        }
      />
    );
  }

  return (
    <FiltersDesktop
      data={filtersData}
      handleToggleFilters={(filtersSelected) =>
        handleToggleFilters(filtersSelected)
      }
    />
  );
}

export default Filters;
